import { useEffect, useRef, useState } from 'react'
import { WithChildren } from '../../../../_metronic/helpers'
import { useAppDispatch, useAppSelector } from '../../store/Store'
import { selectAuth, signOut } from '../Auth.slice'
import { LayoutSplashScreen } from '../../../../_metronic/layout/core'
import { useGetUserByIdMutation } from '../../profile/Profile.api'
import jwt_decode from 'jwt-decode'
import { useGetOrganizationByIdMutation } from '../../organization/Organization.api'
import { tokenService } from '../../../service/Token.service'
import { useRefreshSessionMutation } from '../Auth.api'
import jwtDecode from 'jwt-decode';

export default function AuthProvider({ children }: WithChildren) {
  const didRequest = useRef(false)
  const [isLoading, setIsLoading] = useState(true)
  const auth = useAppSelector(selectAuth)
  const dispatch = useAppDispatch()
  const [getUserById] = useGetUserByIdMutation()
  const [getOrganizationById] = useGetOrganizationByIdMutation()
  const [refreshSession] = useRefreshSessionMutation();

  const isTokenExpired = (token: string): boolean => {
    try {
      const decodedToken: any = jwtDecode(token);
      const currentTime = Date.now() / 1000;
      const expireTime = decodedToken.exp;
      return expireTime < currentTime;
    } catch (error) {
      return true;
    }
  }

  useEffect(() => {
    const fetchSessionData = async (idToken: string) => {
      var decoded: any = jwt_decode(idToken)
      getUserById(decoded['custom:userId'])
      getOrganizationById(decoded['custom:organizationId'])
    }

    const checkTokens = async () => {
        try {
          if (!didRequest.current) {
            const tokensList = tokenService.getTokens()?.tokens;
            if (!tokensList || !tokensList.refreshToken) {
              dispatch(signOut())
            } else {
              let idToken = tokensList.idToken;
              if (!idToken || isTokenExpired(idToken)) {
                const sessionRefreshRequestDto = {refreshToken: tokensList.refreshToken};
                const response = await refreshSession(sessionRefreshRequestDto).unwrap();
                idToken = response?.tokens?.idToken;
              } 
              fetchSessionData(idToken)
            }
          }
        } catch (error) {
          dispatch(signOut())
        } finally {
          setIsLoading(false)
        }
    }

    checkTokens()
  }, [])

  return isLoading ? <LayoutSplashScreen /> : <>{children}</>
}

